import React from 'react';
import { Badge } from 'react-bootstrap';
import { calendarSymbols } from './dm.js';
import { v4 as uuid } from 'uuid';
import { bootstrapVariantNames } from '@soulhx/fs-common';

interface ILegendItems {
  options: string[];
}
export const LegendItems = ({ options }: ILegendItems) => {
  return (
    <div>
      {options.map((o, index) => (
        <Badge key={uuid()} pill bg={bootstrapVariantNames[index]}>
          {calendarSymbols[index]} {o}
        </Badge>
      ))}
    </div>
  );
};
